import React from 'react';

interface MercadoPagoLinkSuccessOverlayProps {
  visible: boolean;
}

const MercadoPagoLinkSuccessOverlay: React.FC<MercadoPagoLinkSuccessOverlayProps> = ({ visible }) => {
  if (!visible) return null;

  return (
    <div
      className="mercadopago-link-success"
      role="status"
      aria-live="polite"
      aria-label="Mercado Pago vinculado correctamente"
    >
      <div className="mercadopago-link-success__content">
        <div className="mercadopago-link-success__loader" aria-hidden="true">
          <span className="mercadopago-link-success__orbit mercadopago-link-success__orbit--outer" />
          <span className="mercadopago-link-success__orbit mercadopago-link-success__orbit--inner" />
          <span className="mercadopago-link-success__logo-wrap">
            <img
              src="/logomercadolibreloader.png"
              alt=""
              className="mercadopago-link-success__logo"
            />
          </span>
        </div>

        <div className="mercadopago-link-success__copy">
          <span className="mercadopago-link-success__eyebrow">Conexión confirmada</span>
          <h2>Mercado Pago vinculado</h2>
          <p>Tu cuenta ya está lista para cobrar.</p>
        </div>
      </div>
    </div>
  );
};

export default MercadoPagoLinkSuccessOverlay;
